import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 40000, refetchOnWindowFocus: false } } })
